import { render, staticRenderFns } from "./ProjectDocumentation.vue?vue&type=template&id=527ddb3f&scoped=true&"
import script from "./ProjectDocumentation.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ddb3f",
  null
  
)

export default component.exports